import request from '@/utils/request'
let BASEROOT          = '/visitor/v2'

//展商 客商
export function getRecommendedVisitorList(query) {
  return request({
    url: BASEROOT + '/visitor/browse/all/list',
    // url: BASEROOT + '/visitor/exhibitor/getVisitorList',
    method: 'post',
    data: query
  })
}

//展商 搜索客商
export function searchVisitorList(query) {
  return request({
    url: BASEROOT + '/visitor/browse/all/list',
    method: 'post',
    data: query
  })
}

//展商 客商详情
export function getVisitorDetails(query) {
  return request({
    url: BASEROOT + '/visitor/exhibitor/getVisitorDetails',
    method: 'post',
    data: query
  })
}

//热词
export function getSearchTrendInfo(query) {
  return request({
    url: BASEROOT + '/searchTrend/getSearchTrendInfo',
    method: 'post',
    data: query
  })
}

// 客商 找展品
export function recommendProductList(query) {
  return request({
    // url: BASEROOT + '/productRecommend/visitor/recommendProductList',
    url: BASEROOT + '/product/browse/all/list',
    method: 'post',
    data: query
  })
}

// 客商 找展商
export function getRecommendedExhibitorsList(query) {
  return request({
    // url: BASEROOT + '/exhibitor/visitor/getExhibitorList',
    url: BASEROOT + '/exhibitor/browse/all/list',
    method: 'post',
    data: query
  })
}

// 客商 找展商
export function fetchExhibitorDetails(query) {
  return request({
    url: BASEROOT + '/exhibitor/visitor/exhibitorDetails',
    method: 'post',
    data: query
  })
}

// 获取 展商详情 产品中心 展品可见性数量
export function fetchProductListCount(query) {
  return request({
    url: BASEROOT + '/product/simpleProductListCount',
    method: 'post',
    data: query
  })
}

// 客商 找展商 产品中心
export function fetchExhibitorProduct(query) {
  return request({
    url: BASEROOT + '/product/simpleProductList',
    method: 'post',
    data: query
  })
}

// 客商 搜索展商
export function getExhibitorSearchList(query) {
  return request({
    url: BASEROOT + '/exhibitor/visitor/getExhibitorSearchList',
    method: 'post',
    data: query
  })
}
// 邀约& IM 发送后台，判断是否发送站内信、短信、邮箱
export function sendInviteOrIM(query) {
  return request({
    url: BASEROOT + '/imNotice/sendEmailAndSms',
    method: 'post',
    data: query
  })
}
// 直播中的展品列表
export function fetchLiveProduct(query){
  return request({
    url: BASEROOT + '/liveProduct/getProductList',
    method: 'post',
    data: query
  })
}

export function exhibitorSearchList(query){
  return request({
    url: BASEROOT + '/exhibitor/cac/getExhibitorSearchList',
    method: 'post',
    data: query
  })
}

